// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'健康ID:',spanRows:8,type:'input',modelValue:'coding'},
	{ label:'姓名:',spanRows:8,type:'input',modelValue:'priceCode',op:'selectOptions'},
	{ label:'三无:',spanRows:8,type:'checked',modelValue:'priceCode',op:'selectOptions'},
	
	{ label:'身份证号:',spanRows:12,type:'input',modelValue:'applicableObjectsName',op:"ObjectsOptions",placeholder:'全部',},
	{ label:'性别:',spanRows:12,type:'select',modelValue:'priceCode',op:'selectOptions'},
	
	{ label:'出生日期:',spanRows:12,type:'select',iconDialogVisible:true,modelValue:'chargeProjectName',op:'selectChanceAll'},
	{ label:'年龄:',spanRows:12,type:'input',modelValue:'simpCode'},
	
	{ label:'国籍:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'description'},
	{ label:'婚姻状况:',spanRows:8,type:'select',modelValue:'financialClassIdName',op:"ClassIdOptions",},
	{ label:'民族:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'measurementUnit'},
	
	{ label:'学历:',spanRows:8,type:'input',modelValue:'oneCeilingPrice'},
	{ label:'宗教信仰:',spanRows:8,type:'input',modelValue:'twoCeilingPrice'},
	{ label:'本人电话:',spanRows:8,type:'input',modelValue:'threeCeilingPrice'},
	
	{ label:'职业:',spanRows:8,type:'select',iconDialogVisible:true,modelValue:'expenseCategoryIdName',op:'expenseCategoryIdOptions'},
	{ label:'工作单位:',spanRows:8,type:'select',modelValue:'medicalRecordCostIdName',op:"CostIdOptions",},
	{ label:'ABO血型:',spanRows:8,type:'select',iconDialogVisible:true,modelValue:'statusName',op:'YNuse'},
	
	{ label:'Rh血型:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'standardName'},
	{ label:'其他证件:',spanRows:8,type:'input',modelValue:'standardCode'},
	
	{ label:'出生地址:',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'projectConnotation'},
	{ label:'工作地址:',spanRows:24,type:'input',modelValue:'excludedContent'},
	{ label:'籍贯地址:',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'户口地址:',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'联系地址:',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:' ',spanRows:24,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:'联系人',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'联系人电话:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:'联系人证件:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'证件号:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:'联系人关系:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'联系人地址:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:'合约单位:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'推荐人:',spanRows:12,type:'input',iconDialogVisible:true,modelValue:'remake'},
	
	{ label:'建档机构:',spanRows:6,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'建档人:',spanRows:6,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'建档时间:',spanRows:6,type:'input',iconDialogVisible:true,modelValue:'remake'},
	{ label:'状态:',spanRows:6,type:'input',iconDialogVisible:true,modelValue:'remake'},
	]

